import React from 'react';
import PropTypes from 'prop-types';
import { PassengerOccupations } from '../../../constants';
import TwNativeSelect from '../../TwNativeSelect';

const PassengerOccupationInput = ({
  onChange, value,
}) => (
  <TwNativeSelect
    value={value}
    onChange={(event) => onChange(event.target.value)}
    options={PassengerOccupations}
    defaultOptionLabel="None"
    labelProperty="name"
  />
);

PassengerOccupationInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

PassengerOccupationInput.defaultProps = {
  value: '',
};

export default PassengerOccupationInput;
